import React from "react";

function CookiePolicy() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "60px 24px",
        lineHeight: 1.7,
        color: "#09111f",
      }}
    >
      <h1>Cookie Policy</h1>
      <p><strong>Effective Date:</strong> April 26, 2026</p>

      <p>
        This Cookie Policy explains how <strong>Enyi</strong>, a product of{" "}
        <strong>JirOAK Labs Ltd</strong>, uses cookies and similar
        technologies when you use our website and services.
      </p>

      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device that help websites
        remember information about your visit.
      </p>

      <h2>2. How Enyi Uses Cookies</h2>
      <p>We may use cookies for:</p>

      <ul>
        <li>Keeping users signed in securely</li>
        <li>Remembering session preferences</li>
        <li>Improving performance and reliability</li>
        <li>Understanding general usage trends</li>
        <li>Security and fraud prevention</li>
      </ul>

      <h2>3. Third-Party Services</h2>
      <p>
        Some third-party tools used by Enyi (such as hosting,
        analytics, or authentication providers) may place cookies.
      </p>

      <h2>4. Managing Cookies</h2>
      <p>
        Most browsers allow you to block or delete cookies through browser
        settings, although some features may stop working correctly.
      </p>

      <h2>5. Changes</h2>
      <p>
        We may update this Cookie Policy periodically.
      </p>

      <h2>6. Contact</h2>
      <p>
        Support:{" "}
        <a href="mailto:support@enyi.ai">support@enyi.ai</a>
      </p>
    </div>
  );
}

export default CookiePolicy;